import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/indice/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findIndexes(empresa_cnpj, include) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );
}
